import { Box, Grid, Skeleton } from '@mui/material';
import {
	productPLPSubtitleSX,
	productPLPTitleSX,
} from '@/components/content/CatalogEntryList/styles/typography';
import { combineSX } from '@/utils/combineSX';

export const ProductCardPLPSkeleton = () => (
	<Grid item xs={6} md={4}>
		<Box border="1px solid #DADCE0">
			<Skeleton
				variant="rectangular"
				sx={{
					height: { xs: '200px', sm: '290px' },
					width: '100%',
				}}
			/>
			<Box
				sx={{
					width: 'auto',
					height: '124px',
					p: '0px 15px 15px 15px',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between',
				}}
			>
				<Box>
					<Skeleton variant="text" width="100%" sx={productPLPTitleSX} />
					<Skeleton
						variant="text"
						width="90%"
						sx={combineSX([productPLPSubtitleSX, { fontWeight: '300' }])}
					/>
				</Box>
				<Skeleton variant="text" width="50%" />
			</Box>
		</Box>
	</Grid>
);
